/**
 * Floating widget stack layout — call + chat dock + chat float panels share one right offset policy.
 */

export const FAB_GUTTER = 104
export const DOCK_WIDTH = 380
export const CALL_WIDTH = 360
export const CALL_MIN_WIDTH = 52
export const CALL_DIAL_WIDTH = 320
export const FLOAT_PANEL_WIDTH = 328
export const FLOAT_PANEL_GAP = 12

const defaultSlots = () => ({
  call: { visible: false, minimized: false, width: CALL_WIDTH, dial: false },
  chatDock: { open: false, width: DOCK_WIDTH },
})

let slots = defaultSlots()
let layout = { callRight: FAB_GUTTER, floatBase: FAB_GUTTER }
const listeners = new Set()

function callOccupiedWidth(call) {
  if (!call?.visible) return 0
  if (call.minimized) return CALL_MIN_WIDTH
  if (call.dial) return CALL_DIAL_WIDTH
  return call.width || CALL_WIDTH
}

function recomputeLayout() {
  let base = FAB_GUTTER
  if (slots.chatDock.open) base += DOCK_WIDTH
  const callW = callOccupiedWidth(slots.call)
  layout = {
    callRight: base,
    floatBase: base + callW,
  }
  document.documentElement.style.setProperty('--wm-call-right', `${layout.callRight}px`)
  document.documentElement.style.setProperty('--wm-float-base', `${layout.floatBase}px`)
  listeners.forEach((fn) => {
    try { fn(layout) } catch { /* ignore */ }
  })
}

/**
 * @param {'call'|'chatDock'} name
 * @param {Record<string, unknown>} patch
 */
export function setWidgetSlot(name, patch) {
  slots = {
    ...slots,
    [name]: { ...slots[name], ...patch },
  }
  recomputeLayout()
}

export function getWidgetLayout() {
  return layout
}

/** @param {(layout: { callRight: number, floatBase: number }) => void} fn */
export function subscribeWidgetLayout(fn) {
  listeners.add(fn)
  fn(layout)
  return () => listeners.delete(fn)
}

export function floatPanelRight(index) {
  return layout.floatBase + index * (FLOAT_PANEL_WIDTH + FLOAT_PANEL_GAP)
}

/** @param {boolean} open */
export function resetWidgetSlotsForTests(open = false) {
  slots = defaultSlots()
  if (open) slots.chatDock.open = true
  recomputeLayout()
}

recomputeLayout()
